<template lang="pug">
  transition(name="fade")
    .modal(
      v-if="isVisible"
    )
      .modal__overlay(@click="close")
      v-button.modal__close-video(v-if="video" label="Close Modal" icon="close", icon-size="30px", @click="close")
      .modal__content()
        icon-button.modal__close(icon="close", @click="close" size="16px")
        slot(name="content")
</template>

<script>
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import Modal from 'scripts/components/basic/Modal.vue';

  export default {
    name: 'ProductZipModal',
    components: { IconButton },
    extends: Modal,
    props: {
      zipModalHeading: String,
      zipModalBody: String,
    },
    data() {
      return {
        isVisible: false,
      };
    },
    computed: {},
    methods: {
      open() {
        this.isVisible = true;
        this.$emit('open');
      },
      close() {
        this.isVisible = false;
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss">
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    min-height: 100vh;
    overflow-y: auto;
    background-color: transparentize($color-grey-500, 0.5)
  }

  .modal--video {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
  }

  .modal__close {
    color: var(--color-slate-500);
    background-color: transparent;
    border-width: 0;
    position: absolute;
    top: 0;
    right: 0;

    &:hover {
      background-color: transparent;
    }
  }

  .modal__close-video {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
  }

  .modal__content {
    position: absolute;
    left: 50%;
    z-index: 1000;
    margin-bottom: 50px;
    padding: 30px;
    max-width: 100%;
    background-color: var(--color-white);
    border: 1px solid var(--color-grey-300);
    transform: translateX(-50%);
    text-align: center;

    @include mobile-only {
      width: 100%;
      display: flex;
      top: 150px;
      flex-direction: column;
      justify-content: center;
      min-height: 400px;
    }

    @include tablet-up {
      top: 200px;
      padding: 65px;
      min-width: 500px;
    }

    .collection-grid__actions-modal & {
      padding: 0;
    }
  }

  .modal__content--video {
    position: relative;
    left: auto;
    transform: none;
    margin-bottom: 0;
    padding: 10px;
    width: 1200px;
    max-width: 100%;
    min-height: 0;
    background-color: transparent;

    @include desktop-up {
      max-width: 800px;
    }

    &:after {
      z-index: 1000;
    }
  }
  </style>